import React from 'react';
import { 
  Box, 
  Button, 
  FormControl, 
  InputLabel, 
  MenuItem, 
  Select, 
  IconButton,
  Grid,
  Typography 
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const OrderBySelector = ({ 
  availableColumns, 
  orderByConditions, 
  onChange 
}) => {
  const handleAddCondition = () => {
    onChange([...orderByConditions, { column: '', direction: 'ASC' }]);
  };

  const handleRemoveCondition = (index) => {
    const newConditions = orderByConditions.filter((_, i) => i !== index);
    onChange(newConditions);
  };

  const handleColumnChange = (index, column) => {
    const newConditions = [...orderByConditions];
    newConditions[index] = { ...newConditions[index], column };
    onChange(newConditions);
  };

  const handleDirectionChange = (index, direction) => {
    const newConditions = [...orderByConditions];
    newConditions[index] = { ...newConditions[index], direction };
    onChange(newConditions);
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Return top rows based on these columns:
      </Typography>
      {orderByConditions.map((condition, index) => (
        <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
          <Grid item xs={6}>
            <FormControl fullWidth size="small">
              <InputLabel>Column</InputLabel>
              <Select
                value={condition.column}
                onChange={(e) => handleColumnChange(index, e.target.value)}
                label="Column"
              >
                {availableColumns.map((column) => (
                  <MenuItem key={column} value={column}>
                    {column}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <FormControl fullWidth size="small">
              <InputLabel>Direction</InputLabel>
              <Select
                value={condition.direction}
                onChange={(e) => handleDirectionChange(index, e.target.value)}
                label="Direction"
              >
                <MenuItem value="ASC">Ascending</MenuItem>
                <MenuItem value="DESC">Descending</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <IconButton 
              onClick={() => handleRemoveCondition(index)}
              color="error"
              size="small"
            >
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      ))}
      <Button
        startIcon={<AddIcon />}
        onClick={handleAddCondition}
        variant="outlined"
        size="small"
        sx={{ mt: 1 }}
      >
        Add Ordering Condition
      </Button>
    </Box>
  );
};

export default OrderBySelector;
